import React from "react";
import { Ellipse } from "react-konva";
import { CircleShape as ICircleShape } from "../../../../types";
import { mergeRefs } from "../../../../utils/mergeRef";
import { ShapeCommonProps } from "../../types";
import { useShape } from "../ShapeContext/useShape";

export const CircleShape = React.forwardRef<
  React.ComponentRef<typeof Ellipse>,
  ShapeCommonProps
>((commonProps, ref) => {
  const { shape } = useShape();

  const circleShape = shape as ICircleShape;
  const shapeRef = React.useRef<React.ComponentRef<typeof Ellipse>>(null);

  return (
    <Ellipse
      {...commonProps}
      x={circleShape.x}
      y={circleShape.y}
      fill={shape.noFill ? undefined : shape.color}
      stroke={shape.stroke || "transparent"}
      strokeWidth={shape.strokeWidth || 0}
      opacity={shape.locked ? 0.5 : 1}
      ref={mergeRefs([shapeRef, ref])}
      radiusX={circleShape.width / 2}
      radiusY={circleShape.height / 2}
    />
  );
});
